export const filterOptionsByLabel = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());